import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from './AppContext';
import { AppRouter } from './router';
import { applyRuntimeGate } from './mobile-runtime';
import { installHaptics } from './haptics';
import './styles.css';
import './nosivo-design-system.css';
import './mobile-app.css';
import './finance.css';
import './currency-finance.css';

if (applyRuntimeGate()) {
  installHaptics();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProvider>
        <AppRouter />
      </AppProvider>
    </StrictMode>,
  );
}
